import { Map } from "./Map";
import { SearchInput } from "./SearchInput";
import { LocationList } from "./LocationList";
import { initSwup } from "./swup";

export class App {
    constructor() {
        this.$target = document.body;
        this.language = this.$target.dataset.language,
        this.baseurl = this.$target.dataset.baseurl,
        this.params = new URL(document.location).searchParams;
        this.data = '';
        this.getData().then(data => this.init(data));        
        this.state = {
            activeCategories: this.params.get('filter') ? this.params.get('filter') : '',
            isFiltered: this.params.get('filter') ? true : false,
            // useActiveArea: window.location.pathname.includes('/locations'),
            useActiveArea: true,
            popupOnly: this.params.get('popup') && this.params.get('popup') == 'true' ? true : false,
            isolate: this.params.get('isolate') && this.params.get('isolate') == 'true' ? true : false,
            mode: 'map',
            viewOnMap: false,
        }

        this.setState();
    }
    async getData() {
        let url = this.baseurl + '/locations.json';
        let response = await fetch(url);
        let data = await response.json();
        return data;
    }
    setState(state = {}) {
        this.state = {...this.state, ...state};
        for (const [key, value] of Object.entries(this.state)) {
            this.$target.dataset[key] = value;
        }
    }
    setView(template) {
        if (template == 'location') {
            this.setState({useActiveArea: !this.state.popupOnly});

            let zoom = this.map.LMAP.getZoom();
            zoom = zoom >= 15 ? zoom : 15;

            let location = this.$target.querySelector('main').dataset.location;
            let marker = this.map.getMarkerByLocationId(location);
            this.map.setActiveMarker(marker);
            if (!this.state.popupOnly) this.map.LMAP.flyTo(marker.marker._latlng, zoom);

            if (this.state.popupOnly) this.map.activeMarker.marker.openPopup();
        }
        if (template == 'home') {
            this.setState({useActiveArea: !this.state.popupOnly});
            this.updateFilterButtons();
            this.map.setActiveMarker();
            // this.searchInput = new SearchInput({
            //     selector: '.search-input',
            //     targets: '.search-target',
            //     focus: false,
            // })
            this.loclist = new LocationList(this);
            this.placeFiltersWrapper();
        }
    }
    pageLoad() {
        this.$filterButtons = document.querySelectorAll('button.filter-btn');
        this.$viewOnMapButton = document.querySelector('button.view-on-map');
        this.$backToPanelButton = document.querySelector('button.back-to-panel');
        this.$modeToggle = document.querySelector('.mode-toggle');
        this.template = this.$target.querySelector('main').dataset.template;
        this.setView(this.template);
        this.$filterButtons.forEach(button => {
            button.addEventListener('click', e => {
                if (button.dataset.category == '_all_') return this.resetFilters();
                this.filterByCategory(button.dataset.category);
            })
        })
        if (this.$modeToggle) {
            this.$modeToggle.querySelectorAll('button').forEach(button => {
                button.addEventListener('click', () => {
                    this.toggleMode(button.dataset.mode);
                })
            })
        }
        if (this.$viewOnMapButton) {
            this.$viewOnMapButton.addEventListener('click', () => {
                this.setState({viewOnMap: true});
            })
        }
        if (this.$backToPanelButton) {
            this.$backToPanelButton.addEventListener('click', () => {
                this.setState({viewOnMap: false});
            })
        }
    }
    toggleMode(mode) {
        if (['list', 'map'].indexOf(mode) > -1) this.setState({mode});
        this.$modeToggle.querySelectorAll('button').forEach(button => {
            if (button.dataset.mode == mode) {
                button.classList.add('is-active');
            } else {
                button.classList.remove('is-active');
            }
        })
    }
    resetFilters() {
        this.setState({
            activeCategories: this.map.categories,
            isFiltered: false,
        });
        this.map.filterMarkers('_all_');
        this.loclist.filterByCategory('_all_');
        this.updateFilterButtons();
    }
    placeFiltersWrapper() {
        let filters = document.querySelector('.filters-wrapper');
        if (!filters) return;

        if (window.innerWidth >= 580) {
            document.querySelector('.list').prepend(filters);
        } else {
            document.querySelector('main').prepend(filters);
        }

        filters.classList.add('loaded');
    }
    filterByCategory(category) {
        this.setState({
            activeCategories: category,
            isFiltered: true,
        });
        this.map.filterMarkers(category);
        this.loclist.filterByCategory(category);
        this.loclist.list.scrollTop = 0;
        this.updateFilterButtons();
    }
    updateFilterButtons() {
        this.$filterButtons.forEach(button => {
            if (this.state.activeCategories.includes(button.dataset.category)) {
                button.classList.add('is-active');
            } else {
                button.classList.remove('is-active');
            }
        })
    }
    init(mapData) {
        this.map = new Map('map', mapData, this);
        this.swup = initSwup(this);
        this.pageLoad();

        window.addEventListener('resize', debounce(() => {
            this.placeFiltersWrapper();
            if (!this.map.activeMarker) return;
            // console.log(this.map.activeMarker.marker.getPopup().refresh());
        }), 30)
    }
}

function debounce(callback, interval) {
    let debounceTimeoutId;
  
    return function(...args) {
      clearTimeout(debounceTimeoutId);
      debounceTimeoutId = setTimeout(() => callback.apply(this, args), interval);
    };
}